import { z } from "@/hooks/schema";
import { Form, useFormContext } from "@/components/Form";
import { Input } from "@/components/ui/input";
import { getCet } from "@/Api/cep";

export const addressFieldsSchema = z.object({
  zip_code: z.string().optional(),
  street: z.string().optional(),
  number: z.string().optional(),
  neighborhood: z.string().optional(),
  complement: z.string().optional(),
  state: z.string().optional(),
  city: z.string().optional(),
});

export const AddressFieldsStep = () => {
  const { setValue } = useFormContext();

  const handleCepChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const cep = e.target.value.replace(/\D/g, "");

    if (cep.length === 8) {
      try {
        const { data } = await getCet(cep);
        if (!data.erro) {
          setValue?.("street", data.logradouro);
          setValue?.("neighborhood", data.bairro);
          setValue?.("city", data.localidade);
          setValue?.("state", data.uf);
        }
      } catch (error) {
        console.error("Erro ao buscar CEP:", error);
      }
    }
  };

  return (
    <>
      <Form.Row>
        <Form.Field name="zip_code">
          {({ field }) => (
            <Form.Item>
              <Form.Label>CEP</Form.Label>
              <Form.Control>
                <Input
                  {...field}
                  placeholder="CEP"
                  onChange={(e) => {
                    field.onChange(e);
                    handleCepChange(e);
                  }}
                />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>

      <Form.Row>
        <Form.Field name="street">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Rua</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Rua" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>

        <Form.Field name="number">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Número</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Número" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>

      <Form.Row>
        <Form.Field name="neighborhood">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Bairro</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Bairro" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>

        <Form.Field name="complement">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Complemento</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Complemento" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>

      <Form.Row>
        <Form.Field name="state">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Estado</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Estado" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>

        <Form.Field name="city">
          {({ field }) => (
            <Form.Item>
              <Form.Label>Cidade</Form.Label>
              <Form.Control>
                <Input {...field} placeholder="Cidade" />
              </Form.Control>
            </Form.Item>
          )}
        </Form.Field>
      </Form.Row>
    </>
  );
};
